enum VatType {
	Vat0 = "Vat0",
	Vat6 = "Vat6",
	Vat21 = "Vat21"
}

export default VatType;
